module.exports = "<p>\r\n  articulo-subcategoria works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/articulo-subcategoria/articulo-subcategoria.component.html
// module id = ../../../../../src/app/components/articulo-subcategoria/articulo-subcategoria.component.html
// module chunks = main